import { z } from 'zod'

/**
 * Karbantartás-mód form (DEC-OPS-008). `message` a form-on mindig string
 * (üres = nincs üzenet); a submit üres → null-ra konvertál a backend felé.
 */
export const maintenanceSchema = z.object({
  enabled: z.boolean(),
  message: z.string().max(1000, 'Legfeljebb 1000 karakter'),
})

export type MaintenanceFormValues = z.infer<typeof maintenanceSchema>
